export default {
  name: 'Auth',
  functional: true,
  props: {
    authority: {
      type: Array,
      default: () => []
    }
  },
  render (h, { scopedSlots, props, parent }) {
    const result = props.authority.some(i => {
      return parent.$store.state.loginUser.type === i
    })

    return result ? scopedSlots.default() : null
  }
}
